import { render, staticRenderFns } from "./draw2DPieCanvas.vue?vue&type=template&id=0a42c544&scoped=true&"
import script from "./draw2DPieCanvas.vue?vue&type=script&lang=js&"
export * from "./draw2DPieCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a42c544",
  null
  
)

export default component.exports